import { render, staticRenderFns } from "./EditorDialog.vue?vue&type=template&id=5b0ffbf6&scoped=true&"
import script from "./EditorDialog.vue?vue&type=script&lang=js&"
export * from "./EditorDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditorDialog.vue?vue&type=style&index=0&id=5b0ffbf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0ffbf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0ffbf6')) {
      api.createRecord('5b0ffbf6', component.options)
    } else {
      api.reload('5b0ffbf6', component.options)
    }
    module.hot.accept("./EditorDialog.vue?vue&type=template&id=5b0ffbf6&scoped=true&", function () {
      api.rerender('5b0ffbf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/media/EditorDialog.vue"
export default component.exports